export * from "./hotel-last-second-city-page";
export * from "./hotel-last-second-city-page.type";
